/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-recommendations--parent');
    this.flickity = null;
    this.handleResize = this.updateCarousel.bind(this);
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          if (this.flickity) {
            this.flickity.destroy();
            this.flickity = null;
          }

          this.innerHTML = recommendations.innerHTML;

          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');

            if (document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          }
        }

        this.classList.add('product-recommendations--loaded');
        requestAnimationFrame(() => this.updateCarousel());
      })
      .catch(e => {
        console.error(e);
      });
  }

  connectedCallback() {
    this.fetchProducts();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);

    if (this.flickity) this.flickity.destroy();
  }

  visibleColumns() {
    if (window.innerWidth >= 1068) return 4;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  updateCarousel() {
    if (typeof Flickity === 'undefined') return;

    const carousel = this.querySelector('.product-recommendations-carousel');
    if (!carousel) return;

    const cells = carousel.querySelectorAll('li.columns');
    const shouldEnable = cells.length > this.visibleColumns();

    if (shouldEnable && !this.flickity) {
      this.flickity = new Flickity(carousel, {
        cellAlign: 'left',
        cellSelector: 'li.columns',
        contain: true,
        groupCells: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        adaptiveHeight: false,
      });
    } else if (!shouldEnable && this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    } else if (this.flickity) {
      this.flickity.resize();
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);
